import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import ContactImage from '../images/contact-illustration.svg';
import Submit from '../images/submit-icon.svg';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    company: '',
    mobile: '',
    message: '',
  });
  const [productValue, setProductValue] = useState('');
  const [errors, setErrors] = useState({});
  const [isValid, setIsValid] = useState(true);
  //Snackbar
  const [errorMessage, setErrorMessage] = useState("");
  const [openSnackBar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [state, setState] = useState({
    vertical: "top",
    horizontal: "right",
  });
  const { vertical, horizontal } = state;
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleProductChange = (event) => {
    setProductValue(event.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation rules
    const newErrors = {};
    if (!formData.username.trim()) {
      newErrors.username = 'Username is required';
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.company.trim()) {
      newErrors.company = 'Compay Name is required';
    }
    if (!formData.mobile.trim()) {
        newErrors.mobile = 'Mobile Number is required';
    } else if (formData.mobile.length < 10 || formData.mobile.length > 10) {
        newErrors.mobile = 'Please enter 10 digit mobile number';
    }
    if (!formData.message.trim()) {
        newErrors.message = 'Message is required';
    }
    setIsValid(productValue !== ''); 

    // If errors exist, setErrors and prevent form submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    const contactObj = {
        formData: formData,
        product: productValue,
    };

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(contactObj),
    };
    fetch("http://localhost:3000/contac", requestOptions)
    .then((response) => response.json())
    .then((data) => {
        setErrorMessage("Submitted Successfully!");
        setSeverity("success");
        setOpenSnackbar(true);
        // Clear the form after submission
        setFormData({
            username: '',
            email: '',
            company: '',
            mobile: '',
            message: '',
        });
        setProductValue("");
    })
    .catch((e) => {        
        setErrors({});
        //setErrorMessage("Please try again later!");
        setSeverity("error");
        setOpenSnackbar(false);
        // Clear the form after submission
        setFormData({
            username: '',
            email: '',
            company: '',
            mobile: '',
            message: '',
        });
        setProductValue("");
    });
     
    
    // If no errors, submit the form (here you can handle form submission logic)
    console.log('Form submitted:', formData);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };
  return (
    <>    
        <section class="contact-section" id="contact">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="effortly-content wow fadeInDown">
                            <h2>Contact our support team</h2>
                            <p>Reach out to our dedicated support professionals for prompt assistance with any queries or
                                issues related
                                to our software products.</p>
                        </div>
                    </div>
                    <div class="col-lg-4">
                    </div>
                </div>
                <div class="contact-card wow zoomIn">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="contact-content">
                                <h2>Get In Touch</h2>
                                <h3>24/7 Customer Support</h3>
                                <img class="img-fluid" src={ContactImage} alt="contact-illustration" />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <form class="innovly-form" onSubmit={handleSubmit}>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <TextField
                                            placeholder="Name"
                                            name="username"
                                            className="contact-field"
                                            value={formData.username}
                                            onChange={handleChange}
                                            error={!!errors.username}
                                            helperText={errors.username}
                                            fullWidth
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <TextField
                                            placeholder="Company Name"
                                            name="company"
                                            className="contact-field"
                                            value={formData.company}
                                            onChange={handleChange}
                                            error={!!errors.company}
                                            helperText={errors.company}
                                            fullWidth
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <TextField
                                            placeholder="Email"
                                            name="email"
                                            type="email"
                                            className="contact-field"
                                            value={formData.email}
                                            onChange={handleChange}
                                            error={!!errors.email}
                                            helperText={errors.email}
                                            fullWidth
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <TextField
                                            placeholder="Mobile Number"
                                            name="mobile"
                                            type="mobile"
                                            className="contact-field"
                                            value={formData.mobile}
                                            onChange={handleChange}
                                            error={!!errors.mobile}
                                            helperText={errors.mobile}
                                            fullWidth
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        {/* <select class="form-select" aria-label="Default select example">
                                            <option selected>Select Product</option>
                                            <option value="1">Effortly</option>
                                            <option value="2">Email defence</option>
                                            <option value="3">Dlp defence</option>
                                        </select> */}
                                        <FormControl fullWidth className='select-field'>
                                            <InputLabel>Select Product</InputLabel>
                                            <Select
                                                name="product"
                                                value={productValue}
                                                onChange={handleProductChange}
                                                error={!!errors.product}
                                            >
                                                <MenuItem value={'Effortly'}>Effortly</MenuItem>
                                                <MenuItem value={'Email defence'}>Email defence</MenuItem>
                                                <MenuItem value={'Dlp defence'}>Dlp defence</MenuItem>
                                            </Select>
                                            {!isValid && <FormHelperText>Please select a Product</FormHelperText>}
                                        </FormControl>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-message">
                                            <TextField
                                                placeholder="Message"
                                                name="message"
                                                type="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                error={!!errors.message}
                                                helperText={errors.message}
                                                fullWidth
                                                multiline
                                                className="contact-field textarea"
                                                rows={4}
                                            />
                                        </div>
                                    </div>
                                    {/* <div class="google-captcha">
                                        <div class="g-recaptcha" data-sitekey="YOUR_SITE_KEY"></div>
                                    </div> */}
                                    <div class="submit-btn">
                                        <button  type="submit">Send Message <img src={Submit} alt="submit" /></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Snackbar open={openSnackBar}  
            anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleClose}
          key={vertical + horizontal}>
            <Alert
            onClose={handleClose}
            severity={severity}
            variant="filled"
            sx={{ width: '100%' }}
            >
            {errorMessage}
            </Alert>
        </Snackbar>
    </>
  );
};

export default Contact;